// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Alopecia (MINOXIDIL) 3.5.2026 09.17.26" (c1c15297-e2cf-4e0d-abce-df309569fa40). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiAlopeciaMinoxidilAnswerField } from './questions';

export const mdiAlopeciaMinoxidil: FormType<mdiAlopeciaMinoxidilAnswerField> = {
  name: 'Alopecia (MINOXIDIL)',
  validityLength: 25,
  questions: [
    'mdiAlopeciaMinoxidil_typeHairLossExperiencing',
    'mdiAlopeciaMinoxidil_didHairLossBegin',
    'mdiAlopeciaMinoxidil_hairLossGettingWorse',
    'mdiAlopeciaMinoxidil_familyHistoryHairLoss',
    'mdiAlopeciaMinoxidil_whereHairLossLocated',
    'mdiAlopeciaMinoxidil_noticed',
    {
      key: 'mdiAlopeciaMinoxidil_previouslyUsedHairLossTreatments',
      next: {
        condition: {
          'mdiAlopeciaMinoxidil_previouslyUsedHairLossTreatments.yes_please_specify_which_treatments_you':
            true
        },
        key: 'mdiAlopeciaMinoxidil_didTreatmentsHelp',
        els: 'mdiAlopeciaMinoxidil_ever'
      }
    },
    'mdiAlopeciaMinoxidil_didTreatmentsHelp',
    'mdiAlopeciaMinoxidil_ever',
    {
      key: 'mdiAlopeciaMinoxidil_everDiagnosedHighLowBlood',
      next: {
        switch: [
          {
            condition: {
              'mdiAlopeciaMinoxidil_everDiagnosedHighLowBlood.yes_high_blood_pressure':
                true
            },
            key: 'mdiAlopeciaMinoxidil_takeMedicationBloodPressure'
          },
          {
            condition: {
              'mdiAlopeciaMinoxidil_everDiagnosedHighLowBlood.yes_low_blood_pressure':
                true
            },
            key: 'mdiAlopeciaMinoxidil_takeMedicationBloodPressure'
          }
        ],
        els: 'mdiAlopeciaMinoxidil_experiencedRecently'
      }
    },
    'mdiAlopeciaMinoxidil_takeMedicationBloodPressure',
    'mdiAlopeciaMinoxidil_experiencedRecently',
    'mdiAlopeciaMinoxidil_upload35PhotosScalp',
    'mdiAlopeciaMinoxidil_importantClickAttachedLinkReview',
    'mdiAlopeciaMinoxidil_firstMessageDoctor',
    'mdiAlopeciaMinoxidil_complete'
  ]
};
